import React from 'react'
import {Tabs} from 'antd'
import './consultAPP.css'
import '../utils/commonFunc'
import {getSubStringWithDot} from "../utils/commonFunc";

const {TabPane} = Tabs;

class ConsultApp extends React.Component {
    constructor(props) {
        super(props);
        this.newTabIndex = 0;
        const panes = [

        ];
        this.state = {
            activeKey: '1',
            panes,
        };
    }

    componentDidMount(){
        this.props.triggerRef(this)
    };

    updataFileData = () => {
        const { panes } = this.state;
        let actKey;
        if (panes.length === 0) {
            actKey = '1';
        } else {
            actKey = panes[panes.length - 1].key + 1;
        }
        panes.push({title:this.props.tabTitle,content:this.props.fileContent,key:actKey});
        this.setState({panes,
            activeKey:actKey});
    };



    onChange = activeKey => {
        this.setState({ activeKey });
    };

    onEdit = (targetKey, action) => {
        this[action](targetKey);
    };

    add = () => {
        const { panes } = this.state;
        const activeKey = `newTab${this.newTabIndex++}`;
        panes.push({ title: 'New Tab', content: 'Content of new Tab', key: activeKey });
        this.setState({ panes, activeKey });
    };

    remove = targetKey => {
        let { activeKey } = this.state;
        let lastIndex;
        this.state.panes.forEach((pane, i) => {
            if (pane.key === targetKey) {
                lastIndex = i - 1;
            }
        });
        const panes = this.state.panes.filter(pane => pane.key !== targetKey);
        if (panes.length && activeKey === targetKey) {
            if (lastIndex >= 0) {
                activeKey = panes[lastIndex].key;
            } else {
                activeKey = panes[0].key;
            }
        }
        this.setState({ panes, activeKey });
    };

    handleBackgroundTap = (e) => {
        this.props.stopMaopao(e);
    };

    replaceContent = (content)=> {
        if (content !== null) {
            return content.replace(/\n/g,"\n\n")
        }
        return ''

    };

    render(){
        let visible = this.props.visible?'inline':'none';
        return(

            <div onClick={this.handleBackgroundTap} className='div_bottom_style'  style={{display:visible}}>
                <div className='div_consult_style'>
                    <Tabs
                        onChange={this.onChange}
                        activeKey={this.state.activeKey}
                        type="editable-card"
                        onEdit={this.onEdit}
                        hideAdd={true}
                        tabBarGutter={0}
                        tabBarStyle={{border:'none',borderWidth:0+'px'}}
                    >
                        {this.state.panes.map(pane => (

                                <TabPane tabBarStyle={{whiteSpace:'pre-wrap'}}
                                         tab={getSubStringWithDot(9,pane.title)}
                                         key={pane.key}
                                         closable={pane.closable}>
                                        {pane.content}

                                </TabPane>

                        ))}

                    </Tabs>
                </div>
            </div>
        );
    }
}

export default ConsultApp
